import { useCallback, useState } from "react";
import TopNav from "ui/dashboard/topnav";
import Search from "ui/search";
import { PlusIcon } from "@heroicons/react/24/outline";
import { User } from "context/AuthContext";
import DealerList from "ui/dealer-list/dealerList";
import { CreateDealerPage, UpdateDealerPage } from "./page";
enum PageKey {
  Create = "create",
  Update = "update",
  Default = "default",
}
export default function Page() {
  const [curDealer, setCurDealer] = useState<User>(null);
  const [pageKey, setpageKey] = useState(PageKey.Default);

  const onDealerSelect = useCallback((dealer) => {
    setCurDealer(dealer);
  }, []);

  return (
    <div className="flex flex-col items-center h-full mr-6 mb-6">
      <TopNav title="Dealer Management" />
      <div className="flex h-full w-full flex-col md:flex-row md:overflow-hidden bg-white rounded-3xl">
        <div className="w-full flex-none md:w-96  border-r border-neutral-200 pt-5 ">
          <div className="">
            <div className="relative flex flex-1 flex-shrink-0 gap-2 px-6">
              <Search placeholder="Search dealer" />
              <button
                className="flex h-10 items-center rounded-2xl bg-blue-600 px-3 text-sm font-medium text-white transition-colors hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                onClick={() => {
                  setCurDealer(null);
                  setpageKey(PageKey.Create);
                }}
              >
                <PlusIcon className="h-5 text-white" />
              </button>
            </div>
            <DealerList
              onDealerSelect={(dealer) => {
                onDealerSelect(dealer);
                setpageKey(PageKey.Update);
              }}
              curDealer={curDealer}
            />
          </div>
        </div>

        <div className="flex-grow py-3 px-6 overflow-y-auto relative">
          {pageKey === PageKey.Update ? (
            <UpdateDealerPage
              curDealer={curDealer}
              onBack={() => {
                setpageKey(PageKey.Default);
                setCurDealer(null);
              }}
            />
          ) : pageKey === PageKey.Create ? (
            <CreateDealerPage
              curDealer={curDealer}
              onBack={() => setpageKey(PageKey.Default)}
            />
          ) : (
            <div className="flex items-center justify-center h-full font-semibold">
              No Dealer Select
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
